<template>
  <v-row no-gutters>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-smoking</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_smoking') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_smoking }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-briefcase</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_occupation') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_occupation }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-paw</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_pets') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_pets }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-gender-male-female</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_gender') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_gender }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_age') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_age }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-translate</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_language') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_language }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-earth</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_nationality') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_nationality }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-worker</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.flatmate_interests') }}</v-list-item-title>
          <v-list-item-subtitle>{{ flatmate_interests }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";

export default {
  props: ["advert"],
  computed: {
    flatmate_smoking: function() {
      let val = _.get(this.$props.advert, "flatmate_smoking", null);
      if (val) return this.trans(`advert.flatmate_smoking_${val}`);
      return "—";
    },
    flatmate_gender: function() {
      let val = _.get(this.$props.advert, "flatmate_gender", null);
      if (val) return this.trans(`advert.flatmate_gender_${val}`);
      return "—";
    },
    flatmate_occupation: function() {
      let val = _.get(this.$props.advert, "flatmate_occupation", null);
      if (val) return this.trans(`advert.flatmate_occupation_${val}`);
      return "—";
    },
    flatmate_pets: function() {
      let val = _.get(this.$props.advert, "flatmate_pets", null);
      if (val) return this.trans(`advert.flatmate_pets_${val}`);
      return "—";
    },
    flatmate_age: function() {
      let val = _.get(this.$props.advert, "flatmate_age", null);
      if (val) return this.trans(`advert.flatmate_age_${val}`);
      return "—";
    },
    flatmate_language: function() {
      let val = _.get(this.$props.advert, "flatmate_language", null);
      if (val) return this.trans(`advert.flatmate_language_${val}`);
      return "—";
    },
    flatmate_nationality: function() {
      let val = _.get(this.$props.advert, "flatmate_nationality", null);
      if (val) return this.trans(`advert.flatmate_nationality_${val}`);
      return "—";
    },
    flatmate_interests: function() {
      let val = _.get(this.$props.advert, "flatmate_interests", null);
      if (val) return this.trans(`advert.flatmate_interests_${val}`);
      return "—";
    }
  }
};
</script>